import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { observer } from 'mobx-react-lite';
import { FC, Ref, forwardRef } from 'react';

const Transition = forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

interface BasicWebDrawerProps {
    isOpen: boolean;
    onClose: () => void;
    header?: JSX.Element;
    children: JSX.Element;
}

const BasicWebDrawer: FC<BasicWebDrawerProps> = observer(({ isOpen, onClose, header = undefined, children }) => {
    return (
        <Dialog
            open={isOpen}
            TransitionComponent={Transition}
            keepMounted
            maxWidth="sm"
            onClose={onClose}
            aria-describedby="basic-web-drawer"
            sx={{
                "& .MuiDialog-paper": {
                    width: "100%",
                    height: "88%",
                    position: "absolute",
                    bottom: 0,
                    marginBottom: 2,
                    maxWidth: 560
                }
            }}
        >
            <>
                <Box
                    pl={1}
                    pt={1}
                    sx={(theme) => ({
                        position: 'relative',
                        border: 9,
                        // backgroundColor: theme.palette.primary.main,
                        borderColor: "Background",
                        borderTopLeftRadius: 12,
                        borderTopRightRadius: 12,
                        visibility: 'visible',
                        right: 0,
                        left: 0,
                    })}
                >
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={onClose}
                        aria-label="close"
                        sx={{
                            position: "absolute",
                            top: 0,
                            right: 0
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                    {header && header}
                </Box>
                {children}
            </>
        </Dialog>
    );
})

export default BasicWebDrawer;